import { differenceInMilliseconds } from "date-fns";

let sessionExpiration: number | undefined;

export function updateTimeout(remainingMilliseconds: number): void {
  sessionExpiration = Date.now() + remainingMilliseconds;
}

export function invalidateTimeout(): void {
  sessionExpiration = undefined;
}

export function getTimeout(): number | null {
  if (sessionExpiration === undefined) {
    return null;
  }

  return differenceInMilliseconds(new Date(sessionExpiration), new Date());
}

export function isExpired(): boolean {
  const timeout = getTimeout();
  return timeout !== null && timeout < 0;
}
